import React from "react";
import { Home, Scale, BadgeCheck, Landmark } from "lucide-react";
import { Reveal } from "./useReveal";

const BADGES = [
  { icon: Home, label: "Equal Housing Opportunity" },
  { icon: Scale, label: "MLS / REALTOR®" },
  { icon: BadgeCheck, label: "DRE LIC #01926616" },
  { icon: Landmark, label: "Licensed Real Estate & Mortgage Broker" },
];

export const TrustBadges = () => (
  <section className="py-12 bg-white border-t border-[#F5F5F5]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {BADGES.map((b) => (
            <div
              key={b.label}
              data-testid={`trust-badge-${b.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-center gap-3 justify-center md:justify-start px-4 py-4 rounded-xl bg-[#F5F5F5] border border-[#E5E5E5]"
            >
              <b.icon size={22} className="text-[#C9A961] shrink-0" />
              <span className="text-sm font-medium text-[#2D2D37] leading-tight">{b.label}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
